<template>
  <div class="floating-container">
    <div class="icon-block">
      <slot name="icon" />
    </div>
    <div class="description-text">
      <slot name="text" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.floating-container {
  clear: both;
  padding: 15px !important;

  .icon-block {
    float: left;
    margin-right: 20px;
  }

  .description-text {
    font-size: 0.95em;
  }
}
</style>
